import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const ClientChart = ({ dashboardData }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!dashboardData?.months?.length) return [];

    const latestGeneratedMonth = [...dashboardData.months]
      .reverse()
      .find((m) => m.generated_at && m.industry_counts?.length);

    if (!latestGeneratedMonth) return [];

    return latestGeneratedMonth.industry_counts.map((item) => ({
      name: item.industry,
      value: item.count,
    }));
  }, [dashboardData]);

  const hasData = chartData.length > 0;

  return (
    <div className="bg-white rounded-md shadow-lg p-5">
      <h3 className="text-xl font-semibold text-primary mb-6">
        {t("dashboard.clientDashboard.Sectors")} vs{" "}
        {t("agent.noteInfo.interested")}
      </h3>

      <div className="h-[260px] flex items-center justify-center">
        {!hasData ? (
          <p className="text-sm text-gray-400">
            {t("dashboard.clientDashboard.chartNotAvailable")}
          </p>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              margin={{ top: 8, right: 16, left: 16, bottom: 80 }}
            >
              <defs>
                <linearGradient id="barGradient" x1="0" y1="0" x2="0.5" y2="1">
                  <stop offset="0%" stopColor="#136BF0" />
                  <stop offset="100%" stopColor="#0C49A6" />
                </linearGradient>
              </defs>

              <CartesianGrid stroke="#D9D9D9" vertical={false} />

              <XAxis
                dataKey="name"
                interval={0}
                angle={-35}
                textAnchor="end"
                height={70}
                tickFormatter={(value) =>
                  value.length > 15 ? value.substring(0, 15) + "..." : value
                }
              />

              <YAxis
                tick={{ fontSize: 12, fill: "#051D42" }}
                axisLine={{ stroke: "#0B3C88" }}
                tickLine={false}
                allowDecimals={false}
              />

              <Tooltip cursor={{ fill: "rgba(19,107,240,0.08)" }} />

              <Bar
                dataKey="value"
                fill="url(#barGradient)"
                radius={[6, 6, 0, 0]}
                barSize={32}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default ClientChart;
